// src/msalInstance.ts
import { PublicClientApplication } from '@azure/msal-browser';
import { toast } from 'react-toastify';
import { msalConfig } from './B2BLogin';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
}).catch((error) => {
    toast.error('Error initializing MSAL instance:', error);
});

export { msalInstance };
